export default {
  NODE_ENV: process.env.NODE_ENV,
  CLOUD_BUCKET_NAME: process.env.CLOUD_BUCKET_NAME,
  CLOUD_ENDPOINT: process.env.CLOUD_ENDPOINT,
  CLOUD_ENDPOINT_PORT: process.env.CLOUD_ENDPOINT_PORT,
  CLOUD_REGION: process.env.CLOUD_REGION,
  CLOUD_ACCESS_KEY: process.env.CLOUD_ACCESS_KEY,
  CLOUD_SECRET_KEY: process.env.CLOUD_SECRET_KEY,
  FIREBASE_API_KEY: process.env.FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: process.env.FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: process.env.FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: process.env.FIREBASE_MEASUREMENT_ID,
  VERSION: process.env.GIT_SHA,
};
